<template lang="pug">
BriqPanel(data-test-id="segment-selection-panel")
  h2.mb-S Segments
  label Available Segments
  .description Choose which segments can book this resource
  .segment-checkboxes(data-test-id="segment-checkboxes")
    BriqCheckbox(
      v-for="(segment, index) in resourceSegments"
      :label="segment.name"
      :key="index"
      v-model="segment.active"
      :disabled="segment.isUsedByProducts || disabled"
      :help="disabledHelp(segment.isUsedByProducts)"
      :data-test-id="`segment-checkbox-${segment.name}`"
      )
  TwoSegmentsMixOptions(
    v-if="totalSelectedActiveSegments == 2"
    v-model="segmentMixing"
    :disabled="disabled"
    )
  MoreThanTwoSegmentsMixOptions(
    v-if="totalSelectedActiveSegments > 2"
    v-model="segmentMixing"
    :disabled="disabled"
    )
</template>

<script>
import TwoSegmentsMixOptions from './TwoSegmentsMixOptions.vue'
import MoreThanTwoSegmentsMixOptions from './MoreThanTwoSegmentsMixOptions.vue'

export default {
  name: 'SegmentSelectionPanel',
  components: {
    TwoSegmentsMixOptions,
    MoreThanTwoSegmentsMixOptions,
  },
  props: {
    value: {
      type: Array,
      required: true,
    },
    pooled: {
      type: Boolean,
      default: true,
    },
    disabled: Boolean,
    totalSelectedActiveSegments: Number,
  },
  data() {
    return {
      resourceSegments: this.value,
    }
  },
  computed: {
    segmentMixing: {
      get() {
        return this.pooled
      },
      set(v) {
        this.$emit('selectPooled', v)
      },
    },
  },
  methods: {
    disabledHelp(isUsedByProducts) {
      const message = 'This segment is used by products and therefore cannot be disabled'
      return isUsedByProducts ? message : null
    },
  },
  watch: {
    resourceSegments() {
      this.$emit('input', this.resourceSegments)
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/variables.styl'

.description
  {typeSmall}
  color #465366
  margin-bottom 10px

.segment-checkboxes > .briq-form-element
  margin-bottom 0

.segment-checkboxes
  margin-bottom 10px
</style>

<style lang="stylus">
.segment-checkboxes .checkboxes
  padding 5px 0
</style>
